import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import { useSellOrResellAction } from '../../../Sidebar/SidebarBlock/layouts/exclusives/hooks';

import s from './SellYourArtLink.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

export const SellYourArtLink: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  className,
}) => {
  const { t } = useTranslation();

  const [sellOrResellAction, sellOrResellBiData] =
    useSellOrResellAction(deviation);

  return (
    <ActionBarItemWrapper
      className={className}
      popoverWrapperClassName={s['wrapper']}
    >
      <ActionBarButton
        className={s['button']}
        onClick={sellOrResellAction}
        disabled={!sellOrResellAction}
        biData={sellOrResellBiData}
      >
        {t('actionbar.sellYourArt')}
      </ActionBarButton>
    </ActionBarItemWrapper>
  );
};
SellYourArtLink.displayName = 'SellYourArtLink';

export default SellYourArtLink;
